import {
  appendTimestamp,
  getClientDisplayNameById,
  getSelectedClientAppliesToType,
} from "../../common/shared";
import { SERVER_URL } from "../../config";
import axios from "axios";

export const mapInsuranceBEtoFE = (insurance) => {
  insurance.insurancePurposeType = {
    key: insurance.insurancePurposeType,
    name: "Income",
  };

  insurance.insurancePolicyType = {
    key: insurance.insurancePolicyType,
    name: "",
  };

  insurance.policyOwner = {
    id: insurance.policyOwner.appliesToId,
    name: getClientDisplayNameById(insurance.policyOwner.appliesToId),
  };

  const insuranceAppliesToId = insurance.insuredParty
    ? insurance.insuredParty.appliesToId
    : 0;

  insurance.insuredParty = {
    id: insuranceAppliesToId,
    name: getClientDisplayNameById(insuranceAppliesToId),
  };

  insurance.scopeType = insurance.scopeType ? insurance.scopeType : "GLOBAL";

  return insurance;
};

export const mapInsuranceFEtoBE = (insurance) => {
  return {
    ...insurance,
    insurancePurposeType: insurance.insurancePurposeType.key,
    insurancePolicyType: insurance.insurancePolicyType.key,
    policyOwner: {
      appliesToId: insurance.policyOwner.id,
      appliesToType: getSelectedClientAppliesToType(insurance.policyOwner),
    },
    insuredParty: {
      appliesToId: insurance.insuredParty.id,
      appliesToType: getSelectedClientAppliesToType(insurance.insuredParty),
    },
  };
};

export const mapFEInsuranceToBEInsurance = (clientId) => (insurance) => {
  return {
    id: insurance.id,
    name: insurance.name,
    clientId: clientId,
    appliesTo: {
      appliesToId: insurance.appliesTo.id,
      appliesToType: getSelectedClientAppliesToType(insurance.appliesTo),
    },
    scopeType: insurance.scopeType,
    policyType: insurance.policyType.key,
    deathBenefit: insurance.deathBenefit,
    premium: insurance.premium,
    cashValue: insurance.cashValue,
    policyEndDate: insurance.policyEndDate,
    isEdited: insurance.isEdited,
    isCopied: insurance.isCopy,
  };
};

export const mapBEInsurancesPoliciesToFE = (insurance, index) => {
  return {
    id: insurance.id,
    name: insurance.name,
    editIndex: index,
    clientId: insurance.clientId,
    appliesTo: {
      id: insurance.appliesTo.appliesToId,
      name: getClientDisplayNameById(insurance.appliesTo.appliesToId),
    },
    scopeType: insurance.scopeType,
    policyType: {
      key: insurance.policyType,
      name: insurance.policyType === "PERMANENT" ? "Permanent" : "Term",
    },
    deathBenefit: insurance.deathBenefit,
    premium: insurance.premium,
    cashValue: insurance.cashValue,
    policyEndDate: insurance.policyEndDate,
    endDateValid: true,
    isEdited: false,
    isCopied: false,
    inEdit: false,
  };
};

export const getInsuranceList = (advisorId, clientId, t) => {
  console.log("getInsuranceList");

  return new Promise((resolve, reject) => {
    const targetUrl = appendTimestamp(
      `${SERVER_URL}/advisor/${advisorId}/client/${clientId}/insurance`
    );

    axios.get(targetUrl).then((response) => {
      const payload = response.data.payload;
      resolve(payload.map(mapInsuranceBEtoFE));
    });
  });
};

const createInsurance = (advisorId, clientId, insurance) => {
  return new Promise((resolve, reject) => {
    const targetUrl = appendTimestamp(
      `${SERVER_URL}/advisor/${advisorId}/client/${clientId}/insurance`
    );

    axios.post(targetUrl, insurance).then((response) => {
      resolve({});
    });
  });
};

const updateInsurance = (advisorId, clientId, insurance) => {
  return new Promise((resolve, reject) => {
    const targetUrl = appendTimestamp(
      `${SERVER_URL}/advisor/${advisorId}/client/${clientId}/insurance/${insurance.id}`
    );

    axios.put(targetUrl, insurance).then((response) => {
      resolve({});
    });
  });
};

export const saveInsurance = (advisorId, clientId, insurance) => {
  console.log("saveInsurance");

  if (insurance.id === null) {
    return createInsurance(advisorId, clientId, mapInsuranceFEtoBE(insurance));
  }

  return updateInsurance(advisorId, clientId, mapInsuranceFEtoBE(insurance));
};

export const deleteInsurance = (advisorId, clientId, insuranceId) => {
  console.log("deleteInsurance");

  return new Promise((resolve, reject) => {
    const targetUrl = appendTimestamp(
      `${SERVER_URL}/advisor/${advisorId}/client/${clientId}/insurance/${insuranceId}`
    );

    axios.delete(targetUrl).then(() => {
      resolve({});
    });
  });
};

export const getInsurancePolicies = (advisorId, clientId) => {
  console.log("getInsurancePolicies");

  return new Promise((resolve, reject) => {
    const targetUrl = appendTimestamp(
      `${SERVER_URL}/advisor/${advisorId}/client/${clientId}/insurance-policy`
    );

    axios.get(targetUrl).then((response) => {
      resolve(response.data.payload.map(mapBEInsurancesPoliciesToFE));
    });
  });
};

export const saveInsurancePolicies = (advisorId, clientId, insurances) => {
  console.log("saveInsurancePolicies");

  return new Promise((resolve, reject) => {
    const targetUrl = appendTimestamp(
      `${SERVER_URL}/advisor/${advisorId}/client/${clientId}/insurance-policy`
    );
    const payload = insurances.map(mapFEInsuranceToBEInsurance(clientId));

    axios.post(targetUrl, payload).then((response) => {
      resolve(response.data.payload.map(mapBEInsurancesPoliciesToFE));
    });
  });
};

export const deleteInsurancePolicies = (advisorId, clientId, insurances) => {
  console.log("deleteInsurancePolicies");

  return new Promise((resolve, reject) => {
    const targetUrl = appendTimestamp(
      `${SERVER_URL}/advisor/${advisorId}/client/${clientId}/insurance-policy/batch-delete`
    );

    axios.post(targetUrl, insurances).then(() => {
      resolve({});
    });
  });
};
